export const SUMMARY_VAT_LIST = 'SUMMARY_VAT_LIST'
export const SUMMARY_TAX_BASE_LIST = 'SUMMARY_TAX_BASE_LIST'
export const CLEAR_VAT_SUMMARIES = 'CLEAR_VAT_SUMMARIES'
export const CLEAR_TAX_BASE_SUMMARIES = 'CLEAR_TAX_BASE_SUMMARIES'
